import { render, staticRenderFns } from "./greenhouse.vue?vue&type=template&id=1bcc97c6&scoped=true"
import script from "./greenhouse.vue?vue&type=script&lang=js"
export * from "./greenhouse.vue?vue&type=script&lang=js"
import style0 from "./greenhouse.vue?vue&type=style&index=0&id=1bcc97c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcc97c6",
  null
  
)

export default component.exports